import { render } from "./sideBar.vue?vue&type=template&id=749c0b9c&scoped=true"
import script from "./sideBar.vue?vue&type=script&lang=js"
export * from "./sideBar.vue?vue&type=script&lang=js"

import "./sideBar.vue?vue&type=style&index=0&id=749c0b9c&scoped=true&lang=css"

import exportComponent from "D:\\work\\code\\tranWorld\\traneasy-reply(易回复官网)\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-749c0b9c"]])

export default __exports__